export const PROFILE_LINKS_BOTTOM_SHEET_NAME = 'profile-links-bottom-sheet';
